import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57b4874f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_AndroidOutlined = _resolveComponent("AndroidOutlined")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["banner", $props.isHome?'':'bg_banner'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_typography_title, { level: 1 }, {
        default: _withCtx(() => [
          _createTextVNode(" 基于先进AI Agent的实时交互数字人 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_typography_paragraph, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString('星汉未来实时交互数字人产品基于AI大模型、RAG、Agent等多种领先技术打造智慧大脑，' +
          '比传统知识库类型数字人更加智慧，' +
          '支持实时语音/文字/图像多模态交互系统，'+
          '并适配了多种尺寸、各种型号的硬件设备。'))
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_space, {
        size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'large':'small'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_1",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.clickToAidigitalHuman())),
            style: {"width":"135px !important"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 免费试用(SaaS) ")
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_1",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$FN.JumpDownloadApk())),
            style: {"width":"135px !important"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 下载客户端 "),
              _createVNode(_component_AndroidOutlined)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_button, {
            type: "link",
            class: "button_n_1",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$Store.Page().openModal('modalFormCollection','productAidigitalHuman')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 联系我们 ")
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["size"])
    ])
  ], 2 /* CLASS */))
}